'use strict';

var processInclude = require('./base/util');

$(document).ready(function () {
    processInclude(require('./login/login'));
    processInclude(require('./components/formCustomerCompany'));
    processInclude(require('./components/formValidation'));
    processInclude(require('./account/optins'));
});
